import _http from './_http';
let http = _http;

// if (process.env.MOCK) {
//   const mock = require('./_mock.json');
//   http = {
//     get: (bsb)=>
//       Promise.resolve().then(()=> {
//         if (bsb.match('000-000') || bsb.match('000000')) {
//           return Promise.reject(mock.bsb.error);
//         }

//         return {data: mock.bsb.success};
//       }
//     ),
//   };
// };

const baseUrl = '/auth/token';

export default {
  url: `${http.baseUrl}${baseUrl}`,
  token(tempToken) {
    http.defaults.headers.common['Authorization'] = `Bearer ${tempToken}`;

    return http
      .get(`${baseUrl}`)
      .then(({ data }) => (data && data.data ? data.data.token : ''))
      .catch(error => {
        console.error('#### ', `${http.baseUrl}${baseUrl}`);
        console.error('#### ', error);
        return error;
      });
  },
};
